export const calc = (property, expression, fallback) => `
    ${property}: ${fallback};
    ${property}: -webkit-calc(${expression});
    ${property}: calc(${expression});
`;
